import axios from '@/config/httpConfig'
// 搜索用户组
export function SearchGroup(data) {
    return axios.post('/view/searchGroup', data)
}
// 搜索用户组
export function GetSearchGroup(data) {
    return axios.post('/share/searchGroup', data)
}